import { useMutation, useQueryClient, type UseMutateFunction } from '@tanstack/react-query';
import { refereeAppService } from '../services/referee-app.service';
import type { UpdateRefereeInfoRequest, RefereeVerificationInfo } from '../types/referee-app.types';

export function useUpdateRefereeInfo(shareId: string): {
  mutate: UseMutateFunction<RefereeVerificationInfo, Error, UpdateRefereeInfoRequest>;
  isPending: boolean;
  isError: boolean;
  error: Error | null;
  isSuccess: boolean;
} {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: (data: UpdateRefereeInfoRequest) =>
      refereeAppService.updateRefereeInfo(shareId, data),
    onSuccess: (result) => {
      queryClient.setQueryData(['referee-verification', shareId], result);
    },
  });

  return {
    mutate: mutation.mutate,
    isPending: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
    isSuccess: mutation.isSuccess,
  };
}
